import { useContext } from 'react';

import { HoneycombCustomTooltipContext } from '../context/honeycomb-custom-tooltip.context.js';

export const useHoneycombCustomTooltip = () =>
  useContext(HoneycombCustomTooltipContext);
